import { AbstractControl, ValidatorFn } from '@angular/forms';

export function maxIfValidator(max: number, ifCondition: () => boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const conditionTrue = ifCondition();
        let valid = true;
        if (conditionTrue) {
            valid = control.value !== null && control.value !== '' && +control.value <= max;
        }
        return valid ? null : { max: true };
    };
}
